// Strips the protocol, leading www., and trailing slash for display purposes only -
// the real websiteUrl (with protocol) is still used as the link's href.
export function formatDisplayUrl(url: string): string {
  return url.replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/$/, '')
}
